import {
  mutationNames
} from '@/store/storeKeysettings'

import uaqSync from './uaqSync'

import Guid from 'guid'

import moment from 'moment'

import uaqActionType from './uaqActionType'

export default store => {
  store.subscribe(mutation => {
    if (mutation.type === mutationNames.ADD_USERCOMMENT) {
      let guid = Guid.create()
      let myDate = moment().tz('Europe/Amsterdam').unix()
      let actionPayload = {
        Id: guid.value,
        RowCreated: myDate,
        Subscription_Id: store.getters.Subscription_Id,
        ActionType: uaqActionType.AddComment,
        Payload: mutation.payload.comment
      }
      uaqSync.onCommentAdded(actionPayload)
    } else if (mutation.type === mutationNames.ADD_POSTLIKE ||
      mutation.type === mutationNames.ADD_IMAGELIKE ||
      mutation.type === mutationNames.ADD_STREAMLIKE) {
      let guid = Guid.create()
      let myDate = moment().tz('Europe/Amsterdam').unix()
      let actionPayload = {
        Id: guid.value,
        RowCreated: myDate,
        Subscription_Id: store.getters.Subscription_Id,
        ActionType: uaqActionType.AddLike,
        Payload: mutation.payload
      }
      uaqSync.onPostLikeAdded(actionPayload)
    } else if (mutation.type === mutationNames.SET_FORMDATA) {
      let guid = Guid.create()
      let myDate = moment().tz('Europe/Amsterdam').unix()
      let actionPayload = {
        Id: guid.value,
        RowCreated: myDate,
        Subscription_Id: store.getters.Subscription_Id,
        ActionType: uaqActionType.FormData,
        Payload: mutation.payload
      }
      uaqSync.onCommentAdded(actionPayload)
    }
  })
}



// WEBPACK FOOTER //
// ./src/modules/uaq/uaqPlugin.js